import { render, staticRenderFns } from "./DefaultFamilyPermittedFunctionEdit.vue?vue&type=template&id=65c4930e&scoped=true&lang=pug"
import script from "./DefaultFamilyPermittedFunctionEdit.vue?vue&type=script&lang=ts"
export * from "./DefaultFamilyPermittedFunctionEdit.vue?vue&type=script&lang=ts"
import style0 from "./DefaultFamilyPermittedFunctionEdit.vue?vue&type=style&index=0&id=65c4930e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4930e",
  null
  
)

export default component.exports